
import React, { useState } from 'react'
import {  Formik } from 'formik';
import { CreateCategory } from '../../services/company_panel/categoryService';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from "sweetalert2"
import Breadcrums from '../../components/company_panel/common/breadcrumbs';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getBrandId, getCompany } from '../../helpers/commonFunctions';
import { globalLoader } from '../../helpers/global';

const CategoryAdd = () => {

  // page the user was on in the list (carried in the route) so we return there
  const params = useParams()
  const listPage = params?.pgno || 1;
  const breadcrumbs = [
    {
      title: "Category",
      url: `/company/raw_materials/category/list/${listPage}`
    },
    {
      title: "Create category",
      url: ""
    },
  ]
  const navigate = useNavigate()
  const [previewImage, setPreviewImage] = useState("");
  const [submitted, setSubmitted] = useState(false)
  const [parentCategories, setParentCategories] = useState([]);

  return (
    <>
      <div className="page-header d-flex align-items-center">
        <div className="page-header-left">
          <Breadcrums data={breadcrumbs} />
        </div>
        <div className="page-header-right ms-auto">

        </div>
      </div>
      <Formik
        initialValues={{
          name: '',
          parent_id: '',
        }}
        validate={values => {
          const error = {};
          if (!values.name.trim()) {
            error.name = 'Category name is required';
          }
          else if (values.name.length > 100) {
            error.name = 'Category name cannot be longer than 100 characters';
          }
          return error;
        }}

        onSubmit={(values, { setSubmitting }) => {
          globalLoader(true);
          setSubmitted(true)
          let formData = new FormData();
          formData.append('name', values?.name?.trim());
          formData.append('brand_id', getBrandId());
          formData.append('company_id', getCompany().company_id);
          formData.append("category_type", 'category');
          CreateCategory(formData).then(response => {
            setSubmitting(false);
            setSubmitted(false);
            if (response.data.status === 1 || response.data.status === "1") {
              Swal.fire({
                customClass: 'swal-wide',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
                toast: true,
                position: 'top-right',
              });
              setTimeout(() => {
                navigate(`/company/raw_materials/category/list/${listPage}`)
              }, 1000);
              globalLoader(false);
            } else {
              Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: response.data.message,
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
              })
              setSubmitted(false)
              globalLoader(false);
            }
          }).catch(error => {
            globalLoader(false);
            console.log("error ====> ", error);
          })
        }}

      >{({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="card custom-card">
            <div className="card-body">
              <div className="row row-sm">
                <div className='col-lg-6 text-center form-group mb-3'>
                  <label htmlFor='name' className='text-left d-flex'>Category<span className="requirestar">*</span></label>
                  <input name='name' id="name" type='text' onChange={handleChange} onBlur={handleBlur} value={values.name} className='form-control' placeholder='Enter Category' />
                  <span className='text-danger d-flex text-left'>{errors.name && touched.name && errors.name}</span>
                </div>
                <div className='col-lg-6'></div>
                <div className="mt-2">
                  <button className="btn btn-primary mr-2" type="submit" disabled={submitted ? true : null}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
      </Formik>
      <ToastContainer
        position="top-right"
        hideProgressBar={false}
        autoClose={true | 1000}
        newestOnTop={true}
        closeOnClick={false}
        draggable={false}
        rtl={false}
      />
    </>
  );
}

export default CategoryAdd